import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { TicketCheckIcon, CalendarIcon, PrinterIcon, SearchIcon, BuildingIcon } from 'lucide-react';
interface CouponUsedRecord {
  id: string;
  couponCode: string;
  vendor: string;
  amount: number;
  usedDate: string;
  usedBy: string;
  gatePassNo: string;
  vehicleNo: string;
}
const mockData: CouponUsedRecord[] = [{
  id: '1',
  couponCode: 'COUP-3102',
  vendor: 'Metro Cargo Services',
  amount: 250,
  usedDate: '2026-04-03 02:30 PM',
  usedBy: 'Rajesh Kumar',
  gatePassNo: 'GP-2026-0020',
  vehicleNo: 'RJ-14-IJ-7890'
}, {
  id: '2',
  couponCode: 'COUP-6745',
  vendor: 'National Freight Lines',
  amount: 750,
  usedDate: '2026-04-05 11:15 AM',
  usedBy: 'Priya Sharma',
  gatePassNo: 'GP-2026-0025',
  vehicleNo: 'UP-32-OP-0123'
}, {
  id: '3',
  couponCode: 'COUP-2218',
  vendor: 'Logistics Express Pvt Ltd',
  amount: 500,
  usedDate: '2026-04-06 04:45 PM',
  usedBy: 'Amit Patel',
  gatePassNo: 'GP-2026-0003',
  vehicleNo: 'GJ-05-EF-9012'
}, {
  id: '4',
  couponCode: 'COUP-8891',
  vendor: 'FastTrack Transport Co.',
  amount: 350,
  usedDate: '2026-04-08 09:20 AM',
  usedBy: 'Sunil Verma',
  gatePassNo: 'GP-2026-0018',
  vehicleNo: 'MH-12-XY-9999'
}, {
  id: '5',
  couponCode: 'COUP-5540',
  vendor: 'BlueDart Logistics',
  amount: 1000,
  usedDate: '2026-04-09 01:00 PM',
  usedBy: 'Deepak Singh',
  gatePassNo: 'GP-2026-0005',
  vehicleNo: 'RJ-14-IJ-7890'
}, {
  id: '6',
  couponCode: 'COUP-1123',
  vendor: 'SafeMove Carriers',
  amount: 200,
  usedDate: '2026-04-10 10:30 AM',
  usedBy: 'Meena Reddy',
  gatePassNo: 'GP-2026-0006',
  vehicleNo: 'KA-01-KL-2345'
}, {
  id: '7',
  couponCode: 'COUP-7766',
  vendor: 'Metro Cargo Services',
  amount: 450,
  usedDate: '2026-04-11 03:15 PM',
  usedBy: 'Karthik Nair',
  gatePassNo: 'GP-2026-0007',
  vehicleNo: 'TN-09-MN-6789'
}, {
  id: '8',
  couponCode: 'COUP-4432',
  vendor: 'National Freight Lines',
  amount: 600,
  usedDate: '2026-04-12 11:45 AM',
  usedBy: 'Rajesh Kumar',
  gatePassNo: 'GP-2026-0030',
  vehicleNo: 'KA-01-KL-2345'
}, {
  id: '9',
  couponCode: 'COUP-9901',
  vendor: 'Logistics Express Pvt Ltd',
  amount: 300,
  usedDate: '2026-04-13 02:00 PM',
  usedBy: 'Anita Gupta',
  gatePassNo: 'GP-2026-0009',
  vehicleNo: 'MP-09-QR-4567'
}, {
  id: '10',
  couponCode: 'COUP-3355',
  vendor: 'FastTrack Transport Co.',
  amount: 800,
  usedDate: '2026-04-14 04:30 PM',
  usedBy: 'Amit Patel',
  gatePassNo: 'GP-2026-0040',
  vehicleNo: 'MP-09-QR-4567'
}];
export function CouponUsedReportPage() {
  const [startDate, setStartDate] = useState('2026-04-01');
  const [endDate, setEndDate] = useState('2026-04-15');
  const [selectedVendor, setSelectedVendor] = useState('');
  const [hasGenerated, setHasGenerated] = useState(false);
  const vendors = useMemo(() => [...new Set(mockData.map(r => r.vendor))].sort(), []);
  const filteredData = useMemo(() => {
    if (!selectedVendor) return mockData;
    return mockData.filter(r => r.vendor === selectedVendor);
  }, [selectedVendor]);
  const totalAmount = filteredData.reduce((s, r) => s + r.amount, 0);
  const handleGenerate = () => {
    setHasGenerated(true);
  };
  const handlePrint = () => {
    document.body.classList.add('print-a4');
    window.print();
    document.body.classList.remove('print-a4');
  };
  return <div className="w-full max-w-6xl mx-auto" data-id="element-432">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-5 xs:p-6 sm:p-8 no-print" data-id="element-433">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-434">
          <div className="flex items-center gap-3" data-id="element-435">
            <div className="bg-brand-teal/10 p-2 rounded-xl border border-brand-teal/20" data-id="element-436">
              <TicketCheckIcon className="w-6 h-6 text-brand-teal" data-id="element-437" />
            </div>
            <div data-id="element-438">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight" data-id="element-439">
                Coupon Used Report
              </h2>
              <p className="text-sm text-slate-500" data-id="element-440">
                Track all redeemed coupons with vendor and amount details.
              </p>
            </div>
          </div>
          {hasGenerated && <button onClick={handlePrint} className="inline-flex items-center justify-center gap-2 bg-brand-teal text-white px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-brand-tealHover transition-colors" data-id="element-441">
              <PrinterIcon className="w-4 h-4" data-id="element-442" />
              Print Report
            </button>}
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8 p-4 bg-slate-50 rounded-xl border border-slate-200" data-id="element-443">
          <div className="flex-1" data-id="element-444">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-445">
              Vendor
            </label>
            <div className="relative" data-id="element-446">
              <BuildingIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-447" />
              <select value={selectedVendor} onChange={e => {
              setSelectedVendor(e.target.value);
              setHasGenerated(false);
            }} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all appearance-none" data-id="element-448">
                <option value="" data-id="element-449">All Vendors</option>
                {vendors.map(v => <option key={v} value={v} data-id="element-450">
                    {v}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="flex-1" data-id="element-451">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-452">
              Start Date
            </label>
            <div className="relative" data-id="element-453">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-454" />
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-455" />
            </div>
          </div>
          <div className="flex-1" data-id="element-456">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-457">
              End Date
            </label>
            <div className="relative" data-id="element-458">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-459" />
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-460" />
            </div>
          </div>
          <div className="flex items-end" data-id="element-461">
            <button onClick={handleGenerate} className="w-full sm:w-auto px-6 py-2.5 bg-slate-800 text-white rounded-xl font-medium text-sm hover:bg-slate-700 transition-colors flex items-center justify-center gap-2 h-[42px]" data-id="element-462">
              <SearchIcon className="w-4 h-4" data-id="element-463" />
              Generate
            </button>
          </div>
        </div>

        {/* Screen Table */}
        {hasGenerated && <div className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-464">
            <div className="overflow-x-auto" data-id="element-465">
              <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-466">
                <thead className="bg-slate-50 border-b border-slate-200 text-slate-500" data-id="element-467">
                  <tr data-id="element-468">
                    <th className="px-4 py-3 font-semibold" data-id="element-469">Coupon Code</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-470">Vendor</th>
                    <th className="px-4 py-3 font-semibold text-right" data-id="element-471">
                      Amount (₹)
                    </th>
                    <th className="px-4 py-3 font-semibold" data-id="element-472">Used Date</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-473">Used By</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-474">Gate Pass</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-475">Vehicle No.</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-476">
                  {filteredData.map(row => <tr key={row.id} className="hover:bg-slate-50/50 transition-colors" data-id="element-477">
                      <td className="px-4 py-3" data-id="element-478">
                        <span className="font-mono font-bold text-orange-600 bg-orange-50 px-2 py-0.5 rounded-lg text-xs" data-id="element-479">
                          {row.couponCode}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-slate-700 font-medium text-xs max-w-[180px] truncate" data-id="element-480">
                        {row.vendor}
                      </td>
                      <td className="px-4 py-3 text-right font-bold text-slate-900" data-id="element-481">
                        ₹{row.amount.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-slate-600 text-xs" data-id="element-482">
                        {row.usedDate}
                      </td>
                      <td className="px-4 py-3 text-slate-700 text-xs font-medium" data-id="element-483">
                        {row.usedBy}
                      </td>
                      <td className="px-4 py-3 font-mono text-slate-600 text-xs" data-id="element-484">
                        {row.gatePassNo}
                      </td>
                      <td className="px-4 py-3 font-mono text-slate-900 font-bold text-xs" data-id="element-485">
                        {row.vehicleNo}
                      </td>
                    </tr>)}
                </tbody>
                <tfoot className="bg-slate-50 border-t border-slate-200 font-bold text-slate-900" data-id="element-486">
                  <tr data-id="element-487">
                    <td className="px-4 py-3" data-id="element-488">
                      Total: {filteredData.length} coupons
                    </td>
                    <td className="px-4 py-3" data-id="element-489"></td>
                    <td className="px-4 py-3 text-right text-brand-teal" data-id="element-490">
                      ₹{totalAmount.toLocaleString()}
                    </td>
                    <td colSpan={4} className="px-4 py-3" data-id="element-491"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>}
      </motion.div>

      {/* A4 Print Layout */}
      {hasGenerated && <div id="print-a4-report" className="hidden print:block bg-white text-black p-8" data-id="element-492">
          <div className="text-center mb-6 border-b-2 border-black pb-4" data-id="element-493">
            <h1 className="text-2xl font-bold tracking-tight mb-1" data-id="element-494">
              ERPLogiPark
            </h1>
            <p className="text-sm text-gray-600 mb-3" data-id="element-495">
              Plot No. 45, Logistics Hub, Sector 18, Industrial Area, Bangalore
              - 560100
            </p>
            <h2 className="text-xl font-bold uppercase tracking-wider mb-1" data-id="element-496">
              Coupon Used Report
            </h2>
            {selectedVendor && <p className="text-sm font-medium" data-id="element-497">Vendor: {selectedVendor}</p>}
            <p className="text-sm font-medium" data-id="element-498">
              Period: {startDate} to {endDate}
            </p>
          </div>

          <table className="w-full text-left text-[10px] border-collapse" data-id="element-499">
            <thead data-id="element-500">
              <tr className="border-b-2 border-black" data-id="element-501">
                <th className="py-2 px-1 font-bold" data-id="element-502">Coupon Code</th>
                <th className="py-2 px-1 font-bold" data-id="element-503">Vendor</th>
                <th className="py-2 px-1 font-bold text-right" data-id="element-504">Amount (₹)</th>
                <th className="py-2 px-1 font-bold" data-id="element-505">Used Date</th>
                <th className="py-2 px-1 font-bold" data-id="element-506">Used By</th>
                <th className="py-2 px-1 font-bold" data-id="element-507">Gate Pass</th>
                <th className="py-2 px-1 font-bold" data-id="element-508">Vehicle No.</th>
              </tr>
            </thead>
            <tbody data-id="element-509">
              {filteredData.map((row, index) => <tr key={row.id} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-510">
                  <td className="py-1.5 px-1 border-b border-gray-200 font-mono font-bold" data-id="element-511">
                    {row.couponCode}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200" data-id="element-512">
                    {row.vendor}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200 text-right" data-id="element-513">
                    {row.amount.toFixed(2)}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200" data-id="element-514">
                    {row.usedDate}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200" data-id="element-515">
                    {row.usedBy}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200 font-mono" data-id="element-516">
                    {row.gatePassNo}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200 font-mono font-bold" data-id="element-517">
                    {row.vehicleNo}
                  </td>
                </tr>)}
            </tbody>
            <tfoot data-id="element-518">
              <tr className="border-t-2 border-black font-bold" data-id="element-519">
                <td className="py-2 px-1" data-id="element-520">
                  Total: {filteredData.length} coupons
                </td>
                <td className="py-2 px-1" data-id="element-521"></td>
                <td className="py-2 px-1 text-right" data-id="element-522">
                  ₹{totalAmount.toFixed(2)}
                </td>
                <td colSpan={4} className="py-2 px-1" data-id="element-523"></td>
              </tr>
            </tfoot>
          </table>

          <div className="mt-12 text-xs text-gray-500 flex justify-between" data-id="element-524">
            <p data-id="element-525">Generated on: {new Date().toLocaleString()}</p>
            <p data-id="element-526">Page 1 of 1</p>
          </div>
        </div>}
    </div>;
}